module.exports = __webpack_public_path__ + "media/images/smart_phone/projects_change/ico_choice-off-93dc387114188844cdb6dd62bb1407a9.png";